import { Injectable } from '@angular/core';
import { QuestionnaireReview } from '../interfaces/questions.interface';
import { AbstractApiV2Service } from '../../../api/services/abstract-api-v2.service';
import { HttpClient } from '@angular/common/http';
import { CommonQuestionnaireService } from './common-questionnaire.service';
import { BackendErrorTranslatorService } from '../../../services/localization/backend-error-translator.service';

@Injectable({
    providedIn: 'root',
})
export class CifcService extends AbstractApiV2Service<QuestionnaireReview> {
    protected resourceName = 'customer-questionnaire/cifc/table';

    constructor(
        protected readonly commonQuestionnaireService: CommonQuestionnaireService,
        http: HttpClient,
        backendErrorTranslator: BackendErrorTranslatorService,
    ) {
        super(http, backendErrorTranslator);
    }

    public async submitReview(questions: any[]) {
        return await this.http
            .post(`/v2/customer-questionnaire/cifc/review/${this.commonQuestionnaireService.questionnaireId}`, questions)
            .toPromise();
    }
}
